import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { NgModel } from '@angular/forms';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class CampiService {

  constructor(private http: HttpClient) { }

  public getList(page: number, size: number, sort: string, filters?: ModelEventiCalamitosi.CampoSearchableDto) {
    let searchParams = new HttpParams();
    searchParams = searchParams.append('page', `${page}`);
    searchParams = searchParams.append('size', `${size}`);
    searchParams = searchParams.append('sort', `${sort}`);
    for (let key in filters) {
      if (filters[key] !== null && filters[key] !== undefined && filters[key].toString().trim() !== '') {
        searchParams = searchParams.append(key, filters[key]);
      }
    }

    return this.http
      .get<ModelEventiCalamitosi.CampoModuloDTO[]>(`${environment.urls.base}/campo/list`,
        {
          params: searchParams
        });
  }

  public cambiaOrdinamentoCampo(idCampo: number, idTemplate: number, direzione: string, pendingOperation: boolean) {
    let campo: ModelEventiCalamitosi.CampoModuloOrdDuplDTO = {
      idCampo: idCampo,
      idTemplate: idTemplate,
      direzione: direzione,
      pendingOperation: pendingOperation,
    }
    return this.http
      .post<ModelEventiCalamitosi.CampoModuloOrdDuplDTO>(`${environment.urls.base}/campo/cambio-ordinamento`,
        campo,
        {
          observe: 'response'
        });
  }

  public getCampo(idCampo: number, idTemplate: number, tpModulo: number) {
    if (idTemplate !== undefined) {
      return this.http
        .get<ModelEventiCalamitosi.CampoModuloDTO>(`${environment.urls.base}/campo/idCampo/` +
          `${idCampo}` + '/idTemplate/' + `${idTemplate}` + '/tpModulo/' + `${tpModulo}`);
    } else {
      return this.http
        .get<ModelEventiCalamitosi.CampoModuloDTO>(`${environment.urls.base}/campo/idCampo/` +
          `${idCampo}` + '/tpModulo/' + `${tpModulo}`);
    }

  }

  public deleteCampo(idCampo: number, idTemplate: number) {
    return this.http.delete(`${environment.urls.base}/campo/delete/idTemplate/` + `${idTemplate}` + '/idCampo/' + `${idCampo}`);
  }

  public upsertCampo(CampoModuloDTO: ModelEventiCalamitosi.CampoModuloDTO) {
    return this.http
      .post<ModelEventiCalamitosi.CampoModuloDTO>(
        `${environment.urls.base}/campo/upsert`,
        CampoModuloDTO,
        {
          observe: 'response'
        }
      );
  }

  public duplicateCampoConf(idCampo: number, idTemplate: number, tpModulo: number, etichetta: string) {
    let campo: ModelEventiCalamitosi.CampoModuloOrdDuplDTO = {
      idCampo: idCampo,
      idTemplate: idTemplate,
      etichetta: etichetta
    }
    return this.http
      .post<ModelEventiCalamitosi.CampoModuloOrdDuplDTO>(`${environment.urls.base}/campo/duplicate`,
        campo,
        {
          observe: 'response'
        });
  }

  public getCampiGestibiliPerExport(idEvento: number) {
      return this.http
        .get<ModelEventiCalamitosi.CampoGestibileExportDTO[]>(`${environment.urls.base}/segnalazione/campi-gestibili/` + `${idEvento}`);
    }

  }


